import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ef39326"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "serviceEvaluation",
  class: "full-modal-wrapper"
}
const _hoisted_2 = { class: "service-evaluation" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "탑승이력이 없으셔서 평가하실수 없습니다.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "서비스 평가",
      shouldHideBackButton: true,
      onOnClickClose: $setup.onCloseServiceEvaluation
    }),
    _createVNode($setup["ServiceEvaluationQuestions"], {
      ref: "serviceEvaluationQuestions",
      lineSurvey: $setup.lineSurvey,
      onOnReceivedEmptyTargetLines: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowModalNotEvaluatingService(true)))
    }, null, 8 /* PROPS */, ["lineSurvey"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["FooterButton"], {
        class: "base-button",
        title: "평가완료",
        disabled: !$setup.isEvaluable,
        onOnClickFooterButton: $setup.onClickEvaluate
      }, null, 8 /* PROPS */, ["disabled"])
    ]),
    ($setup.showModalNotEvaluatingService)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "서비스 평가 불가",
          okButtonTitle: "확인",
          onOnClickOkButton: $setup.onCloseServiceEvaluation
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}